module.exports = {"341004100":"岩寺镇","341004101":"西溪南镇","341004102":"潜口镇","341004103":"呈坎镇","341004198":"徽州区虚镇","341004200":"洽舍乡","341004201":"杨村乡","341004202":"富溪乡","341004400":"安徽徽州经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341004.json
// module id = 1016
// module chunks = 0